import type { ProductivityGoalResponse } from 'api/__GENERATED';
import { timeUtility } from 'utility';

// Maps a single ProductivityGoal DTO onto the normalized
// `Data.ProductivityTarget` shape. `validFrom` is nullable in the DTO — when
// absent, the goal can't be anchored to a day and is therefore unusable as a
// target; return `undefined` so callers can filter it out.
function toProductivityGoal(
  dto: ProductivityGoalResponse,
): Data.ProductivityTarget | undefined {
  const { id, productivityNumber, validFrom } = dto;

  if (validFrom === null) return undefined;

  const date = timeUtility.timestampToDay(new Date(validFrom).getTime());

  const productivityTarget: Data.ProductivityTarget = {
    id,
    productivity: productivityNumber,
    date,
  };

  return productivityTarget;
}

export { toProductivityGoal };
